module.exports = __webpack_public_path__ + "img/chinaEurope07.18e750cc.png";